import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface FeedbackParams {
    userId?: string;
    experienceRating?: number;
    comment: string;
}

export const feedbackApi = createApi({
    reducerPath: 'feedbackApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_URL,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as any).auth.token || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        submitFeedback: builder.mutation<any, FeedbackParams>({
            query: (data) => ({
                url: '/public/feedback',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const { useSubmitFeedbackMutation } = feedbackApi;
